export default __webpack_public_path__ + "e3b50c7b50693ce34f92ba2fa5539c6b.svg";